module.exports = __webpack_public_path__ + "static/2010-header-8c58c0a1bc0e692106c2b1cb0c1f7fea.jpg";